<template>
	<div class="cd-detail">
		<div class="cd-head">
			<v-icon small color="primary" class="mr-1">{{ ev.icona }}</v-icon>
			<span class="cd-head-title">{{ item.name || 'Regola coupon' }}</span>
			<span class="cd-muted">· {{ ev.label }}</span>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" @click="$emit('codes')"><v-icon left x-small>mdi-ticket-confirmation-outline</v-icon>Codici</v-btn>
			<v-btn x-small outlined color="primary" @click="$emit('edit')"><v-icon left x-small>mdi-pencil-outline</v-icon>Modifica</v-btn>
			<v-btn x-small text color="error" @click="$emit('delete')"><v-icon left x-small>mdi-delete-outline</v-icon>Elimina</v-btn>
		</div>

		<div class="cd-body">
			<!-- come funziona -->
			<div>
				<div class="cd-section">Come funziona</div>
				<div class="cd-box cd-pad">
					<div class="cd-sentence">{{ frase(item) }}</div>
					<div class="cd-facts mt-3">
						<div class="cd-fact">
							<span class="cd-k">Sconto</span><strong class="cd-big">{{ sconto(item) }}</strong>
						</div>
						<div class="cd-fact">
							<span class="cd-k">Ordine minimo</span><span>{{ soglia(item) ? euro(item.price) : 'nessuno' }}</span>
						</div>
						<div class="cd-fact">
							<span class="cd-k">Validità</span><span>{{ validita(item) }}</span>
						</div>
						<div class="cd-fact">
							<span class="cd-k">Utilizzo</span><span>{{ item.utility === 'AUTOMATION' ? 'Automazione' : 'Coupon' }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="cd-side">
				<!-- limiti -->
				<div>
					<div class="cd-section">Limiti</div>
					<div class="cd-box cd-pad cd-small">
						<div class="cd-row">
							<span>Codici emessi</span><strong>{{ item.progress || 0 }} su {{ conLimite ? item.used_total : 'senza limite' }}</strong>
						</div>
						<v-progress-linear v-if="conLimite" :value="percentuale" height="6" rounded :color="esaurito ? 'error' : 'primary'" class="my-1"></v-progress-linear>
						<div v-if="esaurito" class="error--text">Codici esauriti: il carrello rifiuta il coupon.</div>
						<div class="cd-row">
							<span>Utilizzi per cliente</span><strong>{{ item.number_for_customer || '—' }}</strong>
						</div>
					</div>
				</div>

				<!-- a chi / a cosa si applica -->
				<div>
					<div class="cd-section">Si applica a</div>
					<div class="cd-box cd-pad cd-small">
						<div v-if="!referenze.length" class="cd-muted">Tutti i clienti e tutti i prodotti</div>
						<div v-for="(r, i) in referenze" :key="i" class="cd-ref">
							<v-icon x-small class="mr-1">{{ r.icona }}</v-icon
							>{{ r.testo }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { evento, sconto, soglia, euro, validita, frase, formatItemText, nomeCliente } from './formato';

// dettaglio di una regola coupon nella lista: la regola in parole, i limiti e a chi si applica
export default {
	name: 'CouponDetail',
	props: {
		item: { type: Object, required: true },
	},
	computed: {
		ev() {
			return evento(this.item.event);
		},
		// come il carrello: progress >= used_total blocca; used_total assente non limita (e 0 blocca subito)
		conLimite() {
			const v = this.item.used_total;
			return v !== null && v !== undefined && v !== '';
		},
		esaurito() {
			const p = this.item.progress;
			return this.conLimite && p !== null && p !== undefined && Number(p) >= Number(this.item.used_total);
		},
		percentuale() {
			const tot = Number(this.item.used_total) || 0;
			return tot ? Math.min(100, ((Number(this.item.progress) || 0) / tot) * 100) : 100;
		},
		referenze() {
			const c = this.item;
			return [
				...(c.customers || []).map(x => ({ icona: 'mdi-account-outline', testo: `${nomeCliente(x)}${x?.buyer?.email ? ' · ' + x.buyer.email : ''}` })),
				...(c.brands || []).map(x => ({ icona: 'mdi-tag-outline', testo: `Brand ${x?.name || ''}` })),
				...(c.categories || []).map(x => ({ icona: 'mdi-sitemap-outline', testo: `Categoria ${x?.name || x?.string || ''}` })),
				...(c.items || []).map(x => ({ icona: 'mdi-shopping-outline', testo: formatItemText(x) })),
			];
		},
	},
	methods: { sconto, soglia, euro, validita, frase },
};
</script>

<style scoped>
.cd-detail {
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.cd-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.cd-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.cd-body {
	display: grid;
	grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
	gap: 16px;
	padding: 12px;
}
.cd-side {
	display: flex;
	flex-direction: column;
	gap: 16px;
	min-width: 0;
}
.cd-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.cd-muted {
	color: #5f6b7a;
}
.cd-small {
	font-size: 13px;
}
.cd-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
}
.cd-pad {
	padding: 10px 12px;
}
.cd-sentence {
	font-size: 14px;
	line-height: 1.5;
}
.cd-facts {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px 16px;
	font-size: 13px;
}
.cd-fact {
	display: flex;
	flex-direction: column;
}
.cd-k {
	font-size: 11px;
	color: #8a96a3;
}
.cd-big {
	font-size: 20px;
	color: #01579b;
}
.cd-row {
	display: flex;
	justify-content: space-between;
	gap: 8px;
	padding: 2px 0;
}
.cd-ref {
	padding: 2px 0;
	word-break: break-word;
}
@media (max-width: 1023px) {
	.cd-body {
		grid-template-columns: 1fr;
	}
}
@media (max-width: 768px) {
	.cd-body {
		padding: 8px;
	}
	.cd-facts {
		grid-template-columns: 1fr;
	}
}
</style>
